import { useEappStore } from "#src/stores/electronic-application.js";
import { useInstanceSettingsStore } from "#src/stores/instance-settings.js";

export class EappPrefillService {
  #pinia;

  constructor(pinia) {
    this.#pinia = pinia;
  }

  setFromPrefill(defaults, { includeQuoteData = false } = {}) {
    const eApp = useEappStore(this.#pinia);
    const instance = useInstanceSettingsStore(this.#pinia);

    if (!defaults) return;

    if (defaults.resume_url) {
      if (defaults.resume_url === "agent-default") {
        eApp.parent_url = `https://${instance.domain}`;
      } else {
        try {
          const resumeUrl = decodeURIComponent(defaults.resume_url);
          const valid =
            /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(
              resumeUrl
            );

          if (!valid) throw "Invalid URL";

          eApp.parent_url = resumeUrl;
          // eslint-disable-next-line no-unused-vars
        } catch (e) {
          instance.errors.resume_url = true;
        }
      }
    }

    if (!includeQuoteData) return;

    if (defaults.product_id) {
      eApp.selectedQuote = { product: { id: defaults.product_id } };
    }
  }
}
